import {
  BuybackActionTypes,
  FETCH_BUYBACK,
  FETCH_BUYBACK_ERROR,
  FETCH_BUYBACK_SUCCESS,
  SAVE_BUYBACK,
  SAVE_BUYBACK_ERROR,
  SAVE_BUYBACK_SUCCESS,
} from '../../types/actions/Buyback.actions';
import {IBuyback} from '../../types/models/Price';

export interface BuybackState {
  data: IBuyback | null;
  isLoading: boolean;
  isSaving: boolean;
}

const initialState: BuybackState = {
  isSaving: false,
  isLoading: false,
  data: null,
};

export default (
  state = initialState,
  action: BuybackActionTypes,
): BuybackState => {
  switch (action.type) {
    case FETCH_BUYBACK: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case FETCH_BUYBACK_SUCCESS: {
      return {
        isLoading: false,
        isSaving: false,
        data: action.payload,
      };
    }
    case SAVE_BUYBACK_SUCCESS: {
      return {
        ...state,
        isSaving: false,
        data: action.payload,
      };
    }
    case FETCH_BUYBACK_ERROR: {
      return {
        isLoading: false,
        isSaving: false,
        data: null,
      };
    }
    case SAVE_BUYBACK: {
      return {
        ...state,
        isSaving: true,
      };
    }
    case SAVE_BUYBACK_ERROR: {
      return {
        ...state,
        isSaving: false,
      };
    }
    default:
      return state;
  }
};
